import React, { useEffect } from "react";
import { useParams } from "react-router";
import { useHistory } from "../../shared/hooks/useHistory";

export const LearningRedirect = () => {
  const history = useHistory();
  const params = useParams<{ id: string }>();

  useEffect(() => {
    history.replace({
      pathname: `/participant/learning/${params.id}`,
      state: { learningDetails: true },
    });
  }, [history, params.id]);
  return <></>;
};
